import { render, staticRenderFns } from "./pip.vue?vue&type=template&id=1255316d&scoped=true&"
import script from "./pip.vue?vue&type=script&lang=js&"
export * from "./pip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1255316d",
  null
  
)

export default component.exports